"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonPrimaryAction = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
/**
 *
 * A button component that is styled according to our guidelines for primary actions.
 *
 * @example ### Basic example
 *
 * This examples shows a basic rendering of this component
 *
 * ```jsx live noInline
 * file://./__examples__/1_BasicButtonPrimaryComponent.jsx
 * ```
 * @category component
 */
const ButtonPrimaryAction = (props, ref) => {
    const { color = "secondary", variant = "contained", type = "submit", ...other } = props;
    return react_1.default.createElement(Button_1.default, { ...{ color, variant, type, ...other }, ref: ref });
};
exports.ButtonPrimaryAction = ButtonPrimaryAction;
const ButtonPrimaryActionWithRef = react_1.default.forwardRef(exports.ButtonPrimaryAction);
exports.default = ButtonPrimaryActionWithRef;
